/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_NInputs */

const en_tut_jadwal_n = /** @type {(inputs: Tut_Jadwal_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The card and the reminder never start a meeting, never join you, and never switch on a microphone. Reminder text is deliberately generic — the title, agenda, and participant list are not sent with it. Reminders live inside the app only: no email, no external calendar notification.`)
};

const id_tut_jadwal_n = /** @type {(inputs: Tut_Jadwal_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu dan pengingat tidak pernah memulai rapat, tidak menggabungkan Anda, dan tidak menyalakan mikrofon. Isi pengingat sengaja umum — judul, agenda, dan daftar peserta tidak ikut dikirim. Pengingat berjalan di dalam aplikasi saja: tidak ada email dan tidak ada notifikasi ke kalender luar.`)
};

/**
* | output |
* | --- |
* | "The card and the reminder never start a meeting, never join you, and never switch on a microphone. Reminder text is deliberately generic — the title, agenda,..." |
*
* @param {Tut_Jadwal_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_n = /** @type {((inputs?: Tut_Jadwal_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_n(inputs)
	return en_tut_jadwal_n(inputs)
});